<template>
	<span></span>
</template>

<script>
import bsHelper from '../../_helpers/barcode-scan-helper';
import { constants } from "../../constants/constants";

export default {
	name: 'BarcodeScanInterceptor',
	emits: ['loginViaBarcode', 'submitBarcode'],
	props: ['openedFromLogin'],
	components: {},
	data() {
		return {
			barcode: '',
			interval: null
		}
	},
	computed: {},
	created() {},
	mounted() {
		document.addEventListener('keydown', this.scan, true);
	},
	beforeUnmount() {
		document.removeEventListener('keydown', this.scan, true);
		this.interval = null;
		this.barcode;
		this.emmiter.off('loginViaBarcode');
	},
	methods: {
		stopListener() {
			document.removeEventListener('keydown', this.scan, true);
			this.interval = null;
			this.barcode;
			this.emmiter.off('loginViaBarcode');
		},
		scan(evt) {
			if (evt.target.tagName.toLowerCase() == 'button' && evt.key == 'Enter') {
				evt.stopPropagation();
				evt.preventDefault();
			}
			
			if (this.interval) {
				clearInterval(this.interval);
			}
			if (evt.code === 'Enter') {
				if (this.barcode) {
					this.handleBarcode(this.barcode);
				}
				this.barcode = '';
				return
			}
			if (evt.key !== 'Shift') {
				this.barcode += evt.key;
			}
			this.interval = setInterval(() => this.barcode = '', 50);
		},
		handleBarcode(scanned_barcode) {
      const barcode = {
        code: scanned_barcode,
        scanned_type: constants.payerAddedBarcodeType.Scan,
      }

			if (scanned_barcode.length > 16 && scanned_barcode.includes(';')) {
				scanned_barcode = bsHelper(scanned_barcode)

        barcode['code'] = bsHelper(scanned_barcode);
        barcode['scanned_type'] = constants.payerAddedBarcodeType.Swipe;
			}
			/*if (this.openedFromLogin) {
				this.emmiter.emit('loginViaBarcode', scanned_barcode);
			} else {
				this.$emit('submitBarcode', scanned_barcode);
			}*/

      this.$emit('submitBarcode', barcode);
		}
	},
	watch: {}
}
</script>

<style lang="less" scoped></style>
